module.exports = __webpack_public_path__ + "amaze.57419d58.png";